import { View } from "react-native"
import { H4 } from "@/components/standard/BFText"
import { Vertical } from "@/components/standard/BFLayout"
import { DashboardTimeline } from "@/components/timeline/DashboardTimeline"

import { useQuery } from "@tanstack/react-query"
import { loanDashboardQueryOptions } from "@/queries/loan-dashboard"
import { BFColors } from "@/constants/Colors"

export const LoanStatusTracker = ({ loanId }: { loanId: string }) => {
  const { data: timeline } = useQuery({
    ...loanDashboardQueryOptions(loanId),
    select: (data) => {
      return data?.timeline!
    },
  })

  if (!timeline) {
    return null
  }

  return (
    <Vertical className={"gap-1"}>
      <H4 color={"default"}>Status Tracker</H4>
      <View
        style={{
          backgroundColor: BFColors.lightest,
          borderColor: BFColors.lightGrey,
          borderWidth: 1,
          borderRadius: 4,
          padding: 20,
          overflow: "hidden",
        }}
      >
        <DashboardTimeline items={timeline} />
      </View>
    </Vertical>
  )
}
